import { IState } from 'shared/store';

export const selectBestPlaceProviderInfo = (state: IState) => state.rs.bestPlaceReportProviderInfo;
